import {
  updateFunction,
  isValidPANCard,
  isValidPhone,
  isValidPinCode,
  trackBtnClick,
  isValidateName,
} from "@/lib/helper";
import RuppeeIcon from "@/assets/icons/ruppee-icon.svg";
import CalenderIcon from "@/assets/icons/calender-icon.svg";

import Searching from "@/assets/icons/looking.svg";
import BusinessTravel from "@/assets/icons/found.svg";
import EmptyList from "@/assets/icons/noplans.svg";
import Done from "@/assets/icons/Done.svg";

const config = [
  {
    progress: {
      title: "Step 1",
      progress: "0",
      total: "3",
    },
    path: "/about",
    heading: "Welcome to CirclePe Club",
    // subheading: `What should we call you?`,
    fields: [
      // {
      //   type: "text",
      //   label: "Name",
      //   name: "full_name",
      //   required: true,
      //   pattern: "^[a-zA-Z]+(?: [a-zA-Z]+)*$",
      // },
      {
        type: "chipgroup",
        label: "You are a ?",
        name: "leadType",
        options: [
          {
            heading: "Tenant",
            value: "tenant",
            color: "bg-primary-100 text-black",
            icon: Searching,
          },
          {
            heading: "Landlord",
            value: "landlord",
            color: "bg-primary-100 text-black",
            icon: BusinessTravel,
          },
        ],
      },
      {
        type: "dropdown",
        label: "How did you hear about us?",
        name: "manualSource",
        required: false,
        options: [
          {
            value: "LinkedIn",
            label: "LinkedIn",
          },
          {
            value: "WhatsApp",
            label: "WhatsApp",
          },
          {
            value: "Facebook",
            label: "Facebook",
          },
          {
            value: "Instagram",
            label: "Instagram",
          },
          {
            value: "Referral",
            label: "Referral",
          },
          {
            value: "Others",
            label: "Others",
          },
        ],
      },
    ],
    validate: (formData) => formData.leadType,
    // validateText: (formData) => !isValidateName(formData?.full_name),
    onSubmit: updateFunction,
    apiPath: "user/update",
    nextPath: "/renting-status",
    click_name: "Next",
    click_source: "About Screen",
  },
  {
    progress: {
      title: "Step 2",
      progress: "1",
      total: "2",
    },
    path: "/update-landlord",
    heading: "Add Property Details",
    // subheading: `What should we call you?`,
    fields: [
      {
        type: "dropdown",
        label: "City",
        name: "city",
        required: true, // Add if this field is mandatory
        options: [
          {
            value: "Gurugram",
            label: "Gurugram",
          },
          {
            value: "Bengaluru",
            label: "Bengaluru",
          },
          {
            value: "Delhi",
            label: "Delhi",
          },
          {
            value: "Pune",
            label: "Pune",
          },
          {
            value: "Mumbai",
            label: "Mumbai",
          },
          {
            value: "Others",
            label: "Others",
          },
        ],
      },
      {
        type: "chipgroup",
        label: "Property Type",
        name: "propertyType",
        options: [
          {
            heading: "Commercial",
            value: "COMMERCIAL",
            color: "bg-primary-100 text-black",
            icon: Searching,
          },
          {
            heading: "Residential",
            value: "RESIDENTIAL",
            color: "bg-primary-100 text-black",
            icon: BusinessTravel,
          },
        ],
      },
      {
        type: "text",
        label: "Monthly Rent",
        name: "rent",
        required: true,
        pattern: "^[a-zA-Z]+(?: [a-zA-Z]+)*$",
      },
    ],
    validate: (formData) => formData.city && formData.rent && formData.propertyType,
    onSubmit: updateFunction,
    apiPath: "user/save-as-landlord",
    nextPath: "/declined",
    click_name: "Confirm",
    click_source: "Update Landlord Property Details",
  },
  {
    progress: {
      title: "Step 2",
      progress: "2",
      total: "4",
    },
    path: "/preferences",
    heading: "Let's understand your renting plans",
    // subheading: `Please select your current renting status from the options below.`,
    fields: [
      {
        type: "chipgroup",
        label: "Select city",
        name: "city",
        options: [
          {
            heading: "Gurgaon",
            value: "Gurgaon",
            color: "bg-primary-100 text-black",
            // icon: GurgaonIcon,
          },
          {
            heading: "Delhi",
            value: "Delhi",
            color: "bg-primary-100 text-black",
            // icon: DelhiIcon,
          },
          {
            heading: "Noida",
            value: "Noida",
            color: "bg-primary-100 text-black",
            // icon: NoidaIcon,
          },
        ],
        required: true,
      },
      {
        type: "chipgroup",
        label: "Select property type",
        name: "property_type",
        options: [
          {
            heading: "1 BHK",
            value: "1_bhk",
            color: "bg-primary-100 text-black",
          },
          {
            heading: "2 BHK",
            value: "2_bhk",
            color: "bg-primary-100 text-black",
          },
          {
            heading: "3 BHK",
            value: "3_bhk",
            color: "bg-primary-100 text-black",
          },

          {
            heading: "4 BHK+",
            value: "4_bhk+",
            color: "bg-primary-100 text-black",
          },
        ],
        required: true,
      },
      {
        type: "chipgroup",
        label: "When are you planning to move-in ?",
        name: "move_in_plan",
        options: [
          {
            heading: "Immediately",
            value: "immediately",
            color: "bg-primary-100 text-black",
          },
          {
            heading: "15 days",
            value: "within_15_days",
            color: "bg-primary-100 text-black",
          },
          {
            heading: "30 days",
            value: "within_30_days",
            color: "bg-primary-100 text-black",
          },
          {
            heading: "Future",
            value: "in_future",
            color: "bg-primary-100 text-black",
          },
        ],
        required: true,
      },
    ],
    validate: (formData) =>
      formData.city && formData.property_type && formData.move_in_plan,
    onSubmit: (formData) => {
      // handle form submission
    },
    nextPath: "/eligibility-check",
  },
  {
    // progress: {
    //   title: "Step 0",
    //   progress: "0",
    //   total: "2",
    // },
    path: "/landlord-details",
    heading: "Generate Club Offer",
    subheading: "for your Landlord",
    subheadingSize: "text-[20px]",
    fields: [
      {
        type: "text",
        label: "Landlord Name",
        name: "full_name",
        required: true,
      },
      { type: "tel", label: "Landlord Phone", name: "phone", required: true },
      {
        type: "text",
        label: "Finalised Rent Amount",
        name: "rent",
        required: true,
      },
      {
        type: "date",
        label: "Move In Date",
        name: "moveinDate",
        required: true,
        icon: CalenderIcon,
      },
    ],
    validate: (formData) => formData.full_name && isValidPhone(formData?.phone) && formData.rent,
    validateText: (formData) => formData?.full_name?.length < 3,
    onSubmit: updateFunction,
    apiPath: "landlord",
    nextPath: "/view-offer",
    click_name: "Next",
    click_source: "Landlord Details Screen",
    backPath: "/"
  },
  // {
  //   progress: {
  //     title: "Step 1",
  //     progress: "1",
  //     total: "4",
  //   },
  //   path: "/property-details",
  //   heading: "Add Property Details",
  //   subheading: "",
  //   fields: [
  //     {
  //       type: "text",
  //       label: "House No./ Block No.",
  //       name: "houseNo",
  //       required: true,
  //     },
  //     {
  //       type: "text",
  //       label: "Society / Area",
  //       name: "locality",
  //       required: true,
  //     },
  //     // {
  //     //   type: "text",
  //     //   label: "Pincode",
  //     //   name: "pincode",
  //     //   required: true,
  //     //   maxLen: 6,
  //     //   inputMode:"numeric"
  //     // },
  //     {
  //       type: "text",
  //       label: "City",
  //       name: "city",
  //       required: true,
  //       pattern: "^[A-Za-z\\s]*$"
  //     },
  //     {
  //       type: "chipgroup",
  //       label: "Select Property Type",
  //       name: "propertyType",
  //       options: [
  //         { heading: "1 BHK", value: "ONE_BHK", color: "bg-primary-100 text-black" },
  //         { heading: "2 BHK", value: "TWO_BHK", color: "bg-primary-100 text-black" },
  //         { heading: "3 BHK", value: "THREE_BHK", color: "bg-primary-100 text-black" },
  //         { heading: "4 BHK+", value: "FOUR_BHK", color: "bg-primary-100 text-black" },
  //       ],
  //       required: true,
  //     },
  //   ],
  //   validate: (formData) =>
  //     formData.houseNo &&
  //     formData.locality &&
  //     // isValidPinCode(formData.pincode) &&
  //     formData.city &&
  //     formData.propertyType,
  //   onSubmit: updateFunction,
  //   apiPath: "property",
  //   nextPath: "/rent-details",
  //   click_name: "Next",
  //   click_source: "Property Details Screen"
  // },
  {
    progress: {
      title: "Step 2",
      progress: "1",
      total: "2",
    },
    path: "/rent-details",
    heading: "Add Rent Details",
    fields: [
      {
        type: "number",
        label: "Finalised Rent",
        name: "rent",
        inputMode: "numeric",
        required: true,
        icon: RuppeeIcon,
        maxValue: 1000000,
        pattern: "d*",
      },
      {
        type: "date",
        label: "Move In Date",
        name: "moveinDate",
        required: true,
        icon: CalenderIcon,
      },
      {
        type: "chipgroup",
        label: "Tenant Type",
        name: "tenantType",
        options: [
          {
            heading: "Bachelor",
            value: "BACHELOR",
            color: "bg-primary-100 text-black",
          },
          {
            heading: "Family",
            value: "FAMILY",
            color: "bg-primary-100 text-black",
          },
        ],
        required: true,
      },
    ],
    validate: (formData) =>
      formData.rent && formData.moveinDate && formData.tenantType,
    onSubmit: updateFunction,
    apiPath: "property/update-rent-details",
    nextPath: "/invite",
    click_name: "Next",
    click_source: "Rent Details Screen",
  },
  {
    progress: {
      title: "Step 3",
      progress: "2",
      total: "3",
    },
    path: "/eligibility-check",
    heading: "Quick Eligibility Check",
    subheading: "Don't worry, it does not affect your credit score",
    fields: [
      // {
      //   type: "dropdown",
      //   label: "Monthly Income (INR)",
      //   name: "income",
      //   required: true, // Add if this field is mandatory
      //   options: [
      //     {
      //       value: "upto_20000",
      //       label: "Upto 20,000",
      //     },
      //     {
      //       value: "20000_40000",
      //       label: "20,000 - 40,000",
      //     },
      //     {
      //       value: "above_40000",
      //       label: "40,000 and above",
      //     },
      //   ],
      // },
      {
        type: "dropdown",
        label: "Select Move-in City",
        name: "moveInCity",
        required: true, // Add if this field is mandatory
        options: [
          {
            value: "Gurugram",
            label: "Gurugram",
          },
          {
            value: "Bengaluru",
            label: "Bengaluru",
          },
          {
            value: "Delhi",
            label: "Delhi",
          },
          {
            value: "Pune",
            label: "Pune",
          },
          {
            value: "Mumbai",
            label: "Mumbai",
          },
          {
            value: "Others",
            label: "Others",
          },
        ],
      },
      {
        type: "pan",
        label: "Pan Number",
        name: "pan_number",
        required: true,
        consent: true,
        maxLen: 10,
      },
      {
        type: "pincode",
        label: "Pincode (As per Aadhaar)",
        name: "pincode",
        required: true,
        maxLen: 6,
        inputMode: "numeric",
      },
    ],
    consent: true,
    validate: (formData) =>
      isValidPANCard(formData.pan_number) &&
      isValidPinCode(formData.pincode) &&
      formData.moveInCity,
    onSubmit: updateFunction,
    nextPath: "/loading",
    // redirectPath: "/congrats",
    apiPath: "v2/approval/check",
    click_name: "Confirm",
    click_source: "Eligibility Check Screen",
  },
  {
    // progress: {
    //   title: "",
    //   progress: "1",
    //   total: "1",
    // },
    path: "/alt-phone",
    heading: "Phone Number Mismatch",
    subheading: "Don't worry, please provide the phone number ending with ",
    fields: [
      {
        type: "tel",
        label: "Alt Phone",
        name: "phone",
        required: true,
        consent: true,
        maxLen: 10,
      },
    ],
    consent: true,
    validate: (formData) => isValidPhone(formData?.phone),
    onSubmit: updateFunction,
    nextPath: "/loading",
    // redirectPath: "/congrats",
    apiPath: "approval/check",
    click_name: "Next",
    click_source: "Alt Phone Screen",
  },
];

export default config;
